import './App.css';
import { Route, Routes, Outlet, useLocation } from "react-router-dom"
import React, { useState, useEffect } from 'react';
import Login from "./components/login/Login"
import Players from './components/players/Players';
import Player from './components/player/Player';
import Team from './components/team/Team';
import Teams from './components/teams/Teams';
import Countries from './components/countries/Countries';
import Navbar from './components/navbar/Navbar';
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";
import Rosters from './components/rosters/Rosters';
import Coaches from './components/coaches/Coaches';
import Schedule from './components/schedule/Schedule';
import Preseason from './components/preseason/Preseason';
import Stats from './components/stats/Stats';
import Menu from './menu/Menu';
import Searcher from './components/searcher/Searcher';

function App() {

  const [user] = useAuthState(auth);
  const [menuAdmin, setMenuAdmin] = useState(<></>)
  const [menu, setMenu] = useState(<></>)

  const location = useLocation()
  
  useEffect(() => {

    const pathsAdmin = ["/players", "/coaches", "/teams", "/countries", "/schedule"];
    if (user && pathsAdmin.includes(location.pathname)) {
      setMenuAdmin(<Navbar/>)
      document.querySelector('.App').style.display = 'block';
    }
    if (!pathsAdmin.includes(location.pathname)) {
      setMenu(<Menu/>)
    } else {
      setMenu(<></>)
    }
  }, [user, location.pathname]);

  return (
    <div className="App">
        {menuAdmin}
        <Outlet />
        <Routes>
          <Route exact path="/" element={<Rosters />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/players" element={<Players />} />
          <Route exact path="/coaches" element={<Coaches />} />
          <Route exact path="/teams" element={<Teams />} />
          <Route exact path="/team" element={<Team />} />
          <Route exact path="/player" element={<Player />} />
          <Route exact path="/countries" element={<Countries />} />
          <Route exact path="/schedule" element={<Schedule />} />
          <Route exact path="/preseason" element={<Preseason />} />
          <Route exact path="/stats" element={<Stats />} />
          <Route exact path="/searcher" element={<Searcher />} />
        </Routes>
      <div className="footer">
        {menu}
        <p className="text-icons">Icons made by <a href="https://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></p>
      </div>
    </div>
  );
}

export default App;
